
var AboutPageMsg = 'This is About Us page. This page has three main links, Dac Bond, Post-Issuance Securities Compliance and Post-Issuance Tax Compliance. Use tab to go to the next field.';
var lblDacBondDivMsg = "Who we are. Digital Assurance Certification, LLC (or DAC), formerly an affiliate of Ernst & Young, LLP, provides post-issuance securities and tax compliance services to municipal securities market participants, and operates an integrated disclosure repository for obligors' municipal and direct/taxable bond issues. To assist our issuer and obligor clients in complying with municipal bond disclosure requirements under SEC Rule 15c2-12, we provide industry-leading dissemination and compliance technology services, such as compliance templates for operating and financial data, reminders of critical filing deadlines, rating change alerts, and model policies and procedures. Training is also provided through our CPE-approved webinars, taught by leading experts. issuerand DAaobligorDAa who engage DAC as their dissemination agent are entitled to use the DAC seal on their municipal bond offering documents. The DAC seal signifies to brokers-dealers that they can rely on DAC's 2001 SEC no-action letter under Rule 15c2-12 when recommending purchases and sales of municipal bonds in the secondary market. DAC clients may request a Certificate of Compliance certifying their compliance during the past five years with prior continuing disclosure undertakings. Underwriters, municipal advisors and bond lawyers use DAC's Compliance Review Services to assist them in the process of producing or reviewing municipal bond offering documents to determine whether remedial action and additional disclosures are needed in connection with past disclosure failures. DAC assists its issuer and obligor clients in complying with their post-issuance tax compliance requirements by providing post-issuance record retention services and software which allows clients not only to track and model private business use, but also to prepare Schedule K to Form 990 for non-profit obligors. For obligors such as hospital systems, universities and other non-governmental entities that incur debt through both municipal bond and direct/taxable offerings, DAC offers an integrated repository for seamless disclosure of obligors' municipal DAC Bond issues as well as non-municipal direct/taxable issues, all in one place for centralized disclosure to investors. This is the end of the description. Use tab to go to the next section.";
var PageaboutUsSecuritiesDivMsg = "Using the financial and operating data requirements contained in existing continuing disclosure undertakings, DAC's professional staff constructs templates which allow issuers and obligors to easily complete required tables of annually updated financial and operating data based on the full set of previous disclosure requirements, even where requirements have differed from issue to issue, Once completed by an issuer or obligor, each table is reviewed by DAC's accounting staff to compare information inputted against filing requirements. Any discrepancies generate a request for the missing information or further clarification from the issuer or obligor. Anytime the DAC system is used to make filings with the market, our system automatically transmits the filling to the Municipal Securities Rulemaking Board's EMMA system, automatically stores the transmitted document and posts it to the DAC repository, and generates a receipt showing the date and time the information was transmitted and the return receipt from the EMMA system, providing an audit trail evidencing filings for the life of the bonds. For filings of disclosures on non-municipal direct/taxable bond issues, the DAC system automatically stores the document and posts it to the DAC repository, as well as generates a receipt showing the date and time the information was posted on the DAC repository, providing an audit trail evidencing filings for the life of the bonds. DAC also provides issuers and obligors with reminders of critical filing deadlines and alerts when the rating agencies publish a change in the issuer's or obligor's credit rating. In addition, DAC facilitates the development by issuers and obligors of post-issuance securities compliance programs through model policies and procedures and periodic training though our CPE-approved webinars. DAC's Compliance Review Services assist issuers and obligors in the process of producing or reviewing municipal bond offering documents to determine whether remedial action or additional disclosures are needed in connection with past disclosure failures. For more information and to view a white paper discussing DAC's History of Innovation, visit the DAC home page at www.dacbond.com and click on the DAC - A History of Innovation for Municipal Securities Market Participants. This is the end of the description. Use tab to go to the next section";
var PostIssuanceTaxComplianceDivMsg = "DAC's innovative post-issuance tax accounting system provides a safe, secure area for clients to store sensitive bond documents, account for proceeds expended and spend down requirements, as well as store bank statements, draw requests, invoices, and the like for the life of the bond plus three years. Issuers receive timely reminders of filing due dates and assistance with preparation of IRS Form 8038-CP and 1097-BTC. DAC also provides Private Business Use services. The DAC system demystifies the calculation of private business use and the preparation of Schedule K to Form 990 by incorporating, in one software application, the complicated Treasury Regulations applicable to financings of separate facilities with separate placed in service dates and separate economic lives. With fast and easy inputs, the DAC system can track the impact of cost of issuance, redemptions, refunding, reimbursements, neutral costs, working capital expenditures, and construction period investment earnings. The DAC system prompts the user for the minimally necessary information and outputs private business use for the reporting period, actual private business use to date, and an estimated private business use percentage for the life of the financing. The system tracks usage by both percentage and dollar amount and alerts the user when specific limitations have been exceeded. The DAC post-issuance tax accounting system is not intended to replace legal assistance or render opinions; basically, it's a sophisticated calculator that allows the user to know, at any time, with exacting precision, the amount of private business use for any bond issue. The system even allows the user to model future numbers to plan ahead for expected changes in private use. Therefore, the DAC system allows the user to plan for the future and maximize the available private use amounts. The user can effectively model what if scenarios instantly and with complete confidence. This is the end of the description. Use tab to go to the footer";

var speakValue = "";
var inputValue = "";
var inputplaceholder = "";
var typingTimer;                //timer identifier
var doneTypingInterval = 1800;  //time in ms
var tabKeyCode = 9;
var enterKeyCode = 13;
var DisplayUserInput = "";
var speakValueOnKeyPress = "";

function AboutPageLoad() {
  //debugger;
  responsiveVoice.cancel();
  if ($('#hidVoiceOnOff').val() == 'ON') {
    responsiveVoice.speak(AboutPageMsg, ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
  }
  AboutCaption(AboutPageMsg, tabKeyCode);  
}

/*------------------------------------------------------------------
      Common Function for Caption.
------------------------------------------------------------------*/
function AboutCaption(newCaptionInput, keyCode) {
  debugger;
  if (keyCode == tabKeyCode) {
    var oldCaption = "";
    var newCaption = "";
    oldCaption = document.getElementById('txtCaptions').value;
    newCaption = oldCaption + "\n" + newCaptionInput;
    if (oldCaption == "") {
      newCaption = newCaptionInput;
    }
    if (newCaptionInput != "") {
      document.getElementById("txtCaptions").value = newCaption;
      var $textCaptionArea = $('#txtCaptions');
      $textCaptionArea.scrollTop($textCaptionArea[0].scrollHeight);
    }
  }
  if (keyCode == enterKeyCode) {
    var oldCaption = "";
    var newCaption = "";
    oldCaption = document.getElementById('txtCaptions').value;
    newCaption = oldCaption + "\n" + newCaptionInput;
    if (oldCaption == "") {
      newCaption = newCaptionInput;
    }
    if (newCaptionInput != "") {
      document.getElementById("txtCaptions").value = newCaption;
      var $textCaptionArea = $('#txtCaptions');
      $textCaptionArea.scrollTop($textCaptionArea[0].scrollHeight);
    }
  }
}

/*------------------------------------------------------------------
      Common Function for speak which is connected with registration component.ts file.
------------------------------------------------------------------*/
function AboutresponsiveVoiceSpeak(inputplaceholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key) {
  debugger;
  
    if (controlType == "text") {
      if (inputValue == "") {
        AboutspeakForAnchorTagControlType(inputValue, inputplaceholder, keyCode);
      }
    }
    if (controlType == "textarea") {
      
      AboutspeakForAnchorTagControlType(inputValue, keyCode);
    }
  if (eventId == "PageaboutUsSecurities" || eventId == "PostIssuanceTaxCompliance" || eventId == "lblDacBond") {
      AboutspeakForAnchorTagControlType(innerText, title, keyCode);
  }

  if (eventId == "lblabout") {
    responsiveVoice.cancel();
    //responsiveVoice.speak(innerText);
    HomeCaption(innerText, keyCode);
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak(innerText + '.' + "Use tab to go to the first section.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    HomeCaption("Use tab to go to the first section.", keyCode);
  }



  //if (eventId == "divAboutTitle") {
  //  responsiveVoice.cancel();
  //  responsiveVoice.speak(innerText);
  //  HomeCaption(innerText, keyCode);
  //  if ($('#hidVoiceOnOff').val() == 'ON') {
  //    responsiveVoice.speak(innerText + '.' + "Use tab to go to the next field.");
  //  }
  //  HomeCaption("Use tab to go to the next field.", keyCode);
  //}
}




/*------------------------------------------------------------------
      Common Function for anchor controls.
------------------------------------------------------------------*/
function AboutspeakForAnchorTagControlType(innerText, title, keyCode) {
  //debugger;
  responsiveVoice.cancel();
  if ($('#hidVoiceOnOff').val() == 'ON') {
    if (innerText == 'A-') {
      responsiveVoice.speak("A. Minus", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    else {
      responsiveVoice.speak(innerText + ' ' + "Use Enter Key to select this link or use tab to go to the next field.", ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
  }
  AboutCaption(innerText, keyCode);
  //responsiveVoice.speak(title);
  AboutCaption("Use Enter Key to select this link or use tab to go to the next field.", keyCode);
  
}

function voiceForAboutUsMenu(targetID) {
  debugger;
  responsiveVoice.cancel();
  if (targetID == "lblDacBond") {
    document.getElementById("divAboutTitle").tabIndex = 21;
    document.getElementById("divAboutTitle").focus();    
    document.getElementById("PageaboutUsSecurities").tabIndex = 22;
    
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak(lblDacBondDivMsg, ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    AboutCaption(lblDacBondDivMsg, tabKeyCode);
  }
  if (targetID == "PageaboutUsSecurities") {
    document.getElementById("divAboutTitle").tabIndex = 22;
    document.getElementById("divAboutTitle").focus();
    document.getElementById("PostIssuanceTaxCompliance").tabIndex = 23;    

    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak(PageaboutUsSecuritiesDivMsg, ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    AboutCaption(PageaboutUsSecuritiesDivMsg, tabKeyCode);
  }
  if (targetID == "PostIssuanceTaxCompliance") {
    document.getElementById("divAboutTitle").tabIndex = 23;
    document.getElementById("divAboutTitle").focus();
    
    if ($('#hidVoiceOnOff').val() == 'ON') {
      responsiveVoice.speak(PostIssuanceTaxComplianceDivMsg, ADASettings.DefaultVoice, { rate: ADASettings.VoiceSpeedRate });
    }
    AboutCaption(PostIssuanceTaxComplianceDivMsg, tabKeyCode);
  }
}
